import { render, staticRenderFns } from "./ShowModRel.vue?vue&type=template&id=059c266c&scoped=true&"
import script from "./ShowModRel.vue?vue&type=script&lang=js&"
export * from "./ShowModRel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059c266c",
  null
  
)

export default component.exports